import { Canvas } from "fabric";
import ImageObject from "./objects/ImageObject";
import { AvailableTool, ToolOptions } from "./tools/Tool";

export default class CanvasLoader {
  public canvas: Canvas | null = null;

  public activeTool: AvailableTool | null = null;

  public image: ImageObject | null = null;

  private contatinerRef: React.RefObject<HTMLDivElement | null> | null = null;

  constructor(
    canvasElement: HTMLCanvasElement,
    private url: string,
    contatinerRef: React.RefObject<HTMLDivElement | null>
  ) {
    this.canvas = new Canvas(canvasElement);
    this.image = new ImageObject(this.url);
    this.contatinerRef = contatinerRef;
  }

  async init() {
    if (!this.canvas || !this.image) return;

    try {
      await this.image.init();
      if (this.image.object) this.canvas.add(this.image.object);
    } catch (error) {
      throw new Error("Failed to load image");
    }
  }

  setActiveTool(tool: AvailableTool) {
    this.activeTool?.deactivate?.();

    this.activeTool = tool;
    this.activeTool.activate?.();
  }

  updateToolOptions(options: ToolOptions) {
    this.activeTool?.updateOptions?.(options);
  }

  setDimensions(imgWidth: number, imgHeight: number) {
    if (!this.canvas || !this.contatinerRef?.current || !this.image?.object)
      return;

    const maxWidth = this.contatinerRef.current.clientWidth;
    const maxHeight = this.contatinerRef.current.clientHeight;

    const scale = Math.min(maxWidth / imgWidth, maxHeight / imgHeight, 1);
    const scaledWidth = Math.round(imgWidth * scale);
    const scaledHeight = Math.round(imgHeight * scale);

    this.canvas.setDimensions(
      {
        width: imgWidth,
        height: imgHeight,
      },
      { backstoreOnly: true }
    );

    this.canvas.setDimensions(
      {
        width: scaledWidth,
        height: scaledHeight,
      },
      { cssOnly: true }
    );
  }

  dispose() {
    this.canvas?.dispose();
    this.canvas = null;

    if (this.image?.object) {
      this.image.object.dispose();
    }
    this.image = null;

    this.activeTool = null;

    this.contatinerRef = null;
  }
}
